import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/residential-status');
}
//Get all active
export function allActive(){
    return http().get('/residential-status/active');
}
//Get Single
export function single(id){
    return http().get(`/residential-status/${id}`);
}
//Add one
export function add(data){
    return http().post('/residential-status', data)
}
//Update
export function update(id, data){
    return http().put(`/residential-status/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/residential-status/${id}`);
}